import { EditedVisualFileType } from 'constants/visualEditing'
import { APIRequest } from 'models/API'
import { LoadEditedVisualResult } from 'models/visualsEditing'
import { runWorker } from './initLoadEditVisualWorker'

export const handleLoadEditedVisuals = async (
  jobId: string,
  assignmentId: string,
  filenames: string[],
  visualType: EditedVisualFileType,
  onResult: (action: LoadEditedVisualResult) => void
) => {
  for (const filename of filenames) {
    const action: LoadEditedVisualResult = {
      jobId,
      assignmentId,
      visualType,
      filename,
      request: new APIRequest(),
    }

    const getWorker: LoadEditedVisualResult | undefined = await runWorker(action)

    if (getWorker) {
      onResult(getWorker)
    }
  }
}
